import { AllocatedPortDataOutput } from './allocated-port-data-output.model';


export class DeviceModelPortSpecificationWithStatusOutput implements IDeviceModelPortSpecificationWithStatusOutput {
    /** The auto-generated id of the device model port specification  master */
    device_model_port_specification_id!: number;
    /** The property name with 255 character limit */
    property_name!: string;
    /** The readingType should be Direct or Inverse  */
    reading_type!: string;
    /** The work hour calculation should be 0 or 1 */
    work_hour_calculation!: number;
    /** Manage status of device model port  specification. 0 For De-active, 1 For Active */
    status!: number;
    selected_port_allocation!: AllocatedPortDataOutput[];

    constructor(data?: IDeviceModelPortSpecificationWithStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_model_port_specification_id = _data["device_model_port_specification_id"];
            this.property_name = _data["property_name"];
            this.reading_type = _data["reading_type"];
            this.work_hour_calculation = _data["work_hour_calculation"];
            this.status = _data["status"];
            if (Array.isArray(_data["selected_port_allocation"])) {
                this.selected_port_allocation = [] as any;
                for (let item of _data["selected_port_allocation"])
                    this.selected_port_allocation!.push(AllocatedPortDataOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceModelPortSpecificationWithStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortSpecificationWithStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_model_port_specification_id"] = this.device_model_port_specification_id;
        data["property_name"] = this.property_name;
        data["reading_type"] = this.reading_type;
        data["work_hour_calculation"] = this.work_hour_calculation;
        data["status"] = this.status;
        if (Array.isArray(this.selected_port_allocation)) {
            data["selected_port_allocation"] = [];
            for (let item of this.selected_port_allocation)
                data["selected_port_allocation"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceModelPortSpecificationWithStatusOutput {
    /** The auto-generated id of the device model port specification  master */
    device_model_port_specification_id: number;
    /** The property name with 255 character limit */
    property_name: string;
    /** The readingType should be Direct or Inverse  */
    reading_type: string;
    /** The work hour calculation should be 0 or 1 */
    work_hour_calculation: number;
    /** Manage status of device model port  specification. 0 For De-active, 1 For Active */
    status: number;
    selected_port_allocation: AllocatedPortDataOutput[];
}

